export default {
  tabs: {
    online_shop: 'Magazin online',
    reservations: 'Rezervări',
    storefront: 'Vitrină',
  },
};
